// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1GDpG","log":"ModalInventoryLogs_log__2GB3t","date":"ModalInventoryLogs_date__3BK2D","userName":"ModalInventoryLogs_userName__3RSo7"};